<mat-expansion-panel [expanded]=true>
  <mat-expansion-panel-header>
      <mat-panel-title id="accAccountCodeMaster">
          <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
              <div class="title-container d-flex align-items-center">
                  <mat-label class="doc-no" *ngIf="selectedWorkFlowTaskDescription"> {{selectedWorkFlowTaskDescription ?
          (parentTaskId ? parentTaskId: 1) + ' ' : ''}}
                  </mat-label>
                  <mat-label>{{selectedWorkFlowTaskDescription ? selectedWorkFlowTaskDescription : ''}}
                  </mat-label>
              </div>
              <div class="align-items-center d-flex eip-mr-0">
                  <i class="fa fa-plus-circle" style="margin-top: -10px;" title="Create New Step" (click)="$event.stopPropagation()" *ngIf="!workflowTemplateService.isViewMode" (click)="createNewStep()" aria-hidden="true"></i>
              </div>
          </div>
      </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formGroup">
      <div class="row eip-pt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete ShowTextValueField='N' setId="eipDD4" WaterMarkText="Workflow Task" TextField="dedDescription"  ValueField="dedId" [dataSource]='workFlowTaskList' [defaultValue]="getFormGroupValue('workflow_Status')" [IsDisabled]="workflowTemplateService.isViewMode || workflowTemplateService.isEditMode" [clearValue]='selectedWorkflowTaskClear' (valueChange)='changeWorkflowTask($event)' [IsCascading]='true'>
              </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Complete task within days</mat-label>
                  <input type="number" matInput formControlName="due_Days">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete ShowTextValueField='N' setId="eipInputStatusDD" WaterMarkText="Stage" ValueField="dedId" TextField="dedDescription" [clearValue]='selectedStatusClear' [defaultValue]="getFormGroupValue('sub_Workflow')" [dataSource]='statusList' (valueChange)='changeStatus($event)' [IsCascading]='true' [IsDisabled]="workflowTemplateService.isViewMode">
              </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete ShowTextValueField='N' setId="eipDDintType" WaterMarkText="Integration type" [clearValue]='selectedIntegrateToClear' ValueField="dedId" TextField="dedDescription" [defaultValue]="getFormGroupValue('integration_Type')" [dataSource]='integrateToList' [IsCascading]='true' (valueChange)='changeIntegrateTo($event)' [IsDisabled]="workflowTemplateService.isViewMode">
              </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isTransmittalSelectionRequired == true">
              <EIPAutoComplete ShowTextValueField='N' [formControlName]="index" WaterMarkText="Select Transmittal" *ngIf="isTransmittalSelectionRequired == true" [defaultValue]="getFormGroupValue('transmittal_Page')" ValueField="template_Id" TextField="template_Name" [dataSource]='transmittalCollection' [IsCascading]='false' (valueChange)='onChange_Transmittal($event)' [clearValue]='selectedIntegrateToClear'>
              </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Active</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Active" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Due On</mat-label>
                  <mat-slide-toggle color="primary" (change)="toggle_IsDueOn($event)" formControlName="is_Due_On" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Completed On Manual</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Completed_On_Manual" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Action Required By All</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Action_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Approval Status</mat-label>
                  <mat-slide-toggle (change)="getApprovalStatusValue()" color="primary" formControlName="is_Approval_Status" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Complete All Task</mat-label>
                  <mat-slide-toggle color="primary" formControlName="complete_All_Task" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is CCN Required</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_CCN_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is No of Sheets Change Required</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_No_Of_Sheets_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Signed Copy Required</mat-label>
                  <mat-slide-toggle color="primary" formControlName="Is_SignedCopy_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" style="display: none;">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Update Document Released For</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Communication_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Can Integrate to StageWise Dashboard</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Report_Required" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Show Attachment in DTN</mat-label>
                  <mat-slide-toggle color="primary" formControlName="is_Show_Attachment_In_DTN" [disabled]="workflowTemplateService.isViewMode">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Can Update DCI Progress Level</mat-label>
                  <mat-slide-toggle color="primary" formControlName="can_Update_DCI_Progress_Level" [disabled]="workflowTemplateService.isViewMode"></mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field floatLabel="always" appearance="none">
                <mat-label>Launch Reassign Member Pop-Up</mat-label>
                <mat-slide-toggle color="primary" formControlName="is_Step_For_Reassignment" [disabled]="workflowTemplateService.isViewMode"></mat-slide-toggle>
                <textarea matInput hidden></textarea>
            </mat-form-field>
        </div>
      </div>
      <div class="row back-row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>To</mat-label>
                  <input type="text" matInput formControlName='toSelectedNames' [disabled]="true">
                  <i class="fa fa-shopping-cart shopping-icon" aria-hidden="true" *ngIf="!workflowTemplateService.isViewMode" (click)="openCartDialog('TO')"></i>
              </mat-form-field>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Cc</mat-label>
                  <input type="text" matInput disabled formControlName='ccSelectedNames'>
                  <i class="fa fa-shopping-cart shopping-icon" aria-hidden="true" (click)="openCartDialog('CC')" *ngIf="!workflowTemplateService.isViewMode"></i>
              </mat-form-field>
          </div>
      </div>
  </form>
  <div class="row eip-pl-20 eip-pr-20  m-0" style="background: #e7f3fb;">
      <app-wft-action-kendo-dialog (getActionCartValue)='getActionCartValue($event)' [TemplateDetails]='TemplateDetails'> </app-wft-action-kendo-dialog>
  </div>
  <div class="row m-0 eip-pt-20 eip-pl-20 eip-pr-20 eip-pb-20 justify-content-end flex-grow-1" style="background: #e7f3fb;" *ngIf="!workflowTemplateService.isViewMode">
      <button class="btn btn-primary" type="submit" (click)="saveBodyInputData()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
  </div>
</mat-expansion-panel>